module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.ab9afb3c.png";